module.exports = __webpack_public_path__ + "assets/img/interactive_pic.73d54557.png";